module.exports = __webpack_public_path__ + "img/decorator-dots-yellow.6fbbcbb.svg";